import { PhotoIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';
import { getCdnImageUrl } from '@/utils/image';

interface ProductThumbnailProps {
  url: string | null | undefined;
  /** 表示サイズ(px) */
  size: number;
  className?: string;
}

export const ProductThumbnail = ({ url, size, className }: ProductThumbnailProps) => {
  // 画像の読み込みに失敗したURL。壊れた画像アイコンではなく画像なしと同じ表示にする
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  if (!url || failedUrl === url) {
    return (
      <div
        className={clsx('flex shrink-0 items-center justify-center bg-neutral-100', className)}
        style={{ width: size, height: size }}
      >
        <PhotoIcon className="size-1/2 text-neutral-400" />
      </div>
    );
  }
  return (
    <img
      src={getCdnImageUrl(url, { width: size * 2, height: size * 2 })}
      alt=""
      className={clsx('shrink-0 object-cover', className)}
      style={{ width: size, height: size }}
      loading="lazy"
      onError={() => setFailedUrl(url)}
    />
  );
};
